"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenVerificationResultSchema = void 0;
var zod_1 = require("zod");
var YwtLoginHeadersSchema = zod_1.z.object({
    'device-os': zod_1.z.string(),
    'app-version': zod_1.z.string(),
    'client-agent': zod_1.z.string(),
    'device-os-version': zod_1.z.string(),
    'client-ip': zod_1.z.string().nullable(),
    'device-id': zod_1.z.string().nullable(),
    'push-token': zod_1.z.string().nullable(),
    'ad-id': zod_1.z.string().nullable(),
    'device-model-name': zod_1.z.string().nullable(),
});
exports.TokenVerificationResultSchema = zod_1.z.object({
    memberNo: zod_1.z.number(),
});
